import React from 'react'
import { Link, graphql, useStaticQuery } from "gatsby"

const Button = ({ text, url, type, isLink = false }) => {
  let fontSize;

  switch (type) {
    case 'hero':
      fontSize = 'text-_1824 1024:text-_2532 tracking-wider '
      break
    case 'normal': 
      fontSize = 'text-_1824 1024:text-_2025 tracking-wide'
      break
  }

  return (
    <div 
      className='w-full 1024:w-fit border-[3px] border-solid border-white rounded-lg shadow-classes_button_outer transition duration-200 ease-out hover:scale-90 hover:shadow-classes_button_outer_hover'
      onClick={() => {
        if (!isLink) window.open(url, '_blank')
        else window.open(url, '_self')
      }}
    >
      <div
        className='flex justify-center items-center px-7.5 1024:px-16 py-3.5 bg-[#008510] rounded-lg cursor-pointer shadow-classes_button_inner'
      >
        <h4 className={`font-goldplay font-semibold text-white text-center ${fontSize}`}>
          {text}
        </h4>
      </div>
    </div>

  )
}

export default Button